import {
  createFeatureSelector,
  createSelector,
  MemoizedSelector,
} from '@ngrx/store';
import {
  State,
  eventsStoreFeatureKey,
  selectAllEventsAdapter,
} from '../reducers/events.reducer';
import { DbStatus, ErrorStore, Event } from '@sleipai/sleip-models';
import { dynamicSort } from '../../helpers';
import { OrderByDirection } from 'firebase/firestore';

export const selectEventsStoreState = createFeatureSelector<State>(
  eventsStoreFeatureKey
);

export const isLoaded = (state: State): boolean => state.loaded;
export const isLoading = (state: State): boolean => state.loading;
export const EventsError = (state: State): ErrorStore | null => state.error;

export const selectIsLoading: MemoizedSelector<object, boolean> =
  createSelector(selectEventsStoreState, isLoading);

export const selectIsLoaded: MemoizedSelector<object, boolean> = createSelector(
  selectEventsStoreState,
  isLoaded
);

export const selectEventsError: MemoizedSelector<object, ErrorStore | null> =
  createSelector(selectEventsStoreState, EventsError);

export const selectAllEvents = createSelector(
  selectEventsStoreState,
  selectAllEventsAdapter
);

export const selectEventsByHorseId = (
  horseId: string,
  orderDirection: OrderByDirection = 'desc'
) =>
  createSelector(selectAllEvents, (events: Event[]) => {
    if (events) {
      return (
        events
          .filter(
            (event) =>
              event.horseId === horseId && event.dbStatus === DbStatus.ACTIVE
          )
          .sort(dynamicSort('date', orderDirection)) ?? []
      );
    } else {
      return [];
    }
  });
